import React, { useState, useEffect } from 'react';
import '../css/home.css';
import '../css/wa.css';
import '../css/mb.css';
import BoxHandler from '../components/BoxHandler.js';
import { useNavigate } from "react-router-dom"

import { IoChevronForwardSharp } from "react-icons/io5";
import { MdOutlineArrowForwardIos, MdEdit } from "react-icons/md"
import { IoMdSend } from "react-icons/io";
import { FaRegBuilding, FaRegIdCard, FaRegListAlt, FaRegCalendar, FaRegUser } from "react-icons/fa";
import RandomFoodRecommender from '../components/RandomFoodRecommender';
import { useToast } from "../components/ToastProvider";
import axios from 'axios';
import { fetchUserData } from '../api/getUserData'; // 위에서 작성한 함수

const MyInformation = () => {
    const navigate = useNavigate()    
    
    const showToast = useToast();

    const [userData, setUserData] = useState(null); // 사용자 데이터 상태
    const [userData2, setUserData2] = useState(null); // 사용자 데이터 상태
    const [articleCount, sArticleCount] = useState(0); // 사용자 데이터 상태
    const [notLogined, setNotLogined] = useState(false); // 로그인되지 않은 상태
    const [notification, setNotification] = useState([]); // 로그인되지 않은 상태


    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.reload();
        showToast("로그아웃 되었습니다", { type: "success" })
      };


    const goToLogin = () => {
        window.location.href='/login';
      };

    const goToMy = () => {
    navigate('/my');
    };

    const goToWrite = () => {
        navigate('/community/editor/new');
    };


    const clearNotification = async () => {
        try {
            const token = localStorage.getItem('token');
            if (token) {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/notification/clear`,
                    {
                        token
                    }
                );
                setNotification([]);
            }
        } catch (error) {
            console.error("Failed to like comment:", error);
            alert("로그인 후 사용 가능한 기능입니다.");
            if (error.response && error.response.status === 500) {
                alert("로그인 후 사용 가능한 기능입니다.");
            }
        }
    };



    useEffect(() => {
        const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오기
        if (!token) {
            setNotLogined(true); // 토큰이 없으면 notLogined 활성화
            return;
        }

        const getUserData = async () => {
            try {
                const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/mydata`, { token });
                console.log(data);
                setUserData(data.user); // 사용자 데이터 설정
                const notification  = data.user.notification;
                setNotification(notification);
                sArticleCount(data.articleCount);
            } catch (err) {
                // 실패 시 사용자 데이터를 설정하지 않음
            } finally {
            }
        };

        getUserData();
    }, []); // 컴포넌트가 처음 렌더링될 때 실행


    return (
        <>
            <div className="wa-card hm-profile">
                {notLogined ? (
                   <div className='hm-profile-ct'>
                        <button className='hm-login' onClick={goToLogin}>로그인</button>
                    </div>
                ) : (
                    <div className='hm-profile-ct'>
                        <div className='hm-profile-flex'>
                        <button onClick={goToMy} className='hm-profile-logout padding-no'>내 정보</button>
                        <button onClick={handleLogout} className='hm-profile-logout'>로그아웃</button>
                        </div>
                        
                        <div className='hm-profile-top'>
                        <div className='hm-profile-img wa-profile'>
                            <img src={userData?.profile}></img>
                        </div>
                        <div className='hm-profile-namearea'>
                            <h1>{userData?.username}</h1>
                            <h2>{userData?.email}</h2>
                        </div>
                        </div>

                        <div className='hm-profile-flex-2'>
                        <div className='hm-profile-box' onClick={() => window.location.href = `/search/tag/${userData?.organ}`}>
                            <FaRegBuilding />
                            <span>내 회사</span>
                            <p>{userData?.organ}</p>
                            <MdOutlineArrowForwardIos className='into' />
                        </div>
                        <div className='hm-profile-box' onClick={() => window.location.href = '/my'}>
                            <FaRegIdCard />
                            <span>내 분야</span>
                            <p>
                                {(() => {
                                    const categories = JSON.parse(userData?.category || "[]");
                                    return categories.length > 1 ? (
                                        <>{categories[0]}..외 {categories.length - 1}개</>
                                    ) : (
                                        <>{categories[0]}</>
                                    );
                                })()}
                            </p>
                            <MdOutlineArrowForwardIos className='into' />
                        </div>
                        <div className='hm-profile-box'>
                            <FaRegCalendar />
                            <span>분야 종사 기간</span>
                            <p>{userData?.term}년</p>
                        </div>
                        </div>
                        <div className='hm-profile-flex-2'>
                        <div className='hm-profile-box' onClick={() => window.location.href = '/my'}>
                            <FaRegListAlt />
                            <span>내가 작성한 글</span>
                            <p>{articleCount}</p>
                            <MdOutlineArrowForwardIos className='into' />
                        </div>
                        <div className='hm-profile-box'>
                            <FaRegUser />
                            <span>나를 구독하는 사람</span>
                            <p>
                                {(() => {
                                const followers = JSON.parse(userData?.follower || "[]");
                                return <>총 {followers.length}명</>;
                                })()}
                            </p>
                        </div>
                        </div>
                    </div>
                )}
                    <div className="my-1">
                        <div className='wa-box-title'>알림</div>
                        <div className='hm-noti-ct'>
                        {notLogined ? (
                                <div className='hm-noti' onClick={goToLogin}>
                                    <div className='hm-noti-icon'>😆</div>
                                    <div className='hm-noti-text-area'>
                                    <div className='hm-noti-title'>로그인하세요</div>
                                    <div className='hm-noti-desc'>로그인 후 커뮤니티에 참여하세요.</div>
                                    </div>
                                    <IoChevronForwardSharp/>
                                </div>
                        ) : (
                            <>
                                {notification.map((noti) => (
                                    <div className='hm-noti' onClick={() => window.location.href = noti.targetLink}>
                                        <div className='hm-noti-icon'>{noti.icon}</div>
                                        <div className='hm-noti-text-area'>
                                        <div className='hm-noti-title'>{noti.title}</div>
                                        <div className='hm-noti-desc'>{noti.content}</div>
                                        </div>
                                        <IoChevronForwardSharp/>
                                    </div>
                                ))}

                                <div className='hm-noti'>
                                    <div className='hm-noti-icon'>🤯</div>
                                    <div className='hm-noti-text-area'>
                                    <div className='hm-noti-title'>알림이 더 없네요</div>
                                    <div className='hm-noti-desc'>오늘 메뉴는 <RandomFoodRecommender /> 어떤가요?</div>
                                    </div>
                                    <IoChevronForwardSharp/>
                                </div>
                                <p style={{fontSize:12,color:'gray',marginLeft:5}} onClick={clearNotification}>알림 모두 삭제</p>
                            </>
                        )}
                        </div>
                    </div>
            </div>
        </>
    );
};
export default MyInformation;